import React, { useState } from 'react';
import redirect from '../../assets/redirect.png';
import styles from './ProjectsCards.module.css';

const ProjectsCards = ({ img, name, technologys, description, link, delay }) => {
     const [isOpen, setOpen] = useState(false);

     const handleModalContainerClick = (e) => {
          e.stopPropagation();
     };

     return (
          <div>
               <div
                    data-aos="fade-up"
                    data-aos-delay={delay}
                    data-aos-offset="250"
                    className={styles.card_pc}
               >
                    <div className={styles.card}>
                         <img className={styles.background_img} src={img[0]} alt={name} />
                         <div className={styles.shadow}></div>
                         <div className={styles.card_info}>
                              <p className={styles.text_title}>{name}</p>
                              <p className={styles.text_body}>{technologys}</p>
                              <button className={styles.card_button} onClick={() => setOpen(true)}>
                                   Read More
                              </button>
                         </div>
                    </div>
               </div>
               <div
                    data-aos="fade-up"
                    data-aos-anchor-placement="top-center"
                    className={styles.card_mobile}
               >
                    <div className={styles.card}>
                         <img className={styles.background_img} src={img[0]} alt={name} />
                         <div className={styles.shadow}></div>
                         <div className={styles.card_info}>
                              <p className={styles.text_title}>{name}</p>
                              <p className={styles.text_body}>{technologys}</p>
                              <button className={styles.card_button} onClick={() => setOpen(true)}>
                                   Read More
                              </button>
                         </div>
                    </div>
               </div>

               <div
                    onClick={() => setOpen(false)}
                    className={isOpen === true ? styles.modal_container : styles.none}
               >
                    <div onClick={handleModalContainerClick} className={styles.modal_background}>
                         <img className={styles.modal_image} src={img} alt={name} />
                         <div className={styles.info_modal_container}>
                              <p className={styles.modal_name}>{name}</p>
                              <p className={styles.modal_technologys}>{technologys}</p>
                              <div className={styles.line}></div>
                              <div className={styles.sidemenu}>
                                   <p className={styles.modal_description}>{description}</p>
                              </div>
                         </div>
                         <div className={styles.buttons_modal_container}>
                              <a
                                   className={styles.card_button}
                                   href={link}
                                   target="_blank"
                                   rel="noreferrer"
                              >
                                   View Page
                                   <img
                                        className={styles.redirect_icon}
                                        src={redirect}
                                        alt="redirect"
                                   />
                              </a>
                              <button className={styles.modal_close} onClick={() => setOpen(false)}>
                                   X
                              </button>
                         </div>
                    </div>
               </div>
          </div>
     );
};

export default ProjectsCards;
